"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SCREENS = exports.formatCallClock = exports.getVoiceScreen = void 0;
// First match wins. 'unknown' errors fall back to the call start screen.
exports.getVoiceScreen = function (s) {
    if (s.callError === 'noMic')
        return 'noMic';
    if (s.callError === 'micBlocked')
        return 'micBlocked';
    if (!s.isCalling)
        return 'ready';
    if (!s.isCallConnected)
        return 'connecting';
    if (s.isMuted)
        return 'muted';
    if (s.isBotSpeaking)
        return 'speaking';
    if (s.isUserSpeaking)
        return 'userSpeaking';
    if (s.isThinking)
        return 'thinking';
    return 'listening';
};
exports.formatCallClock = function (seconds) {
    var total = Math.max(0, Math.floor(seconds || 0));
    var pad = function (n) { return (n < 10 ? "0" + n : "" + n); };
    return pad(Math.floor(total / 60)) + ":" + pad(total % 60);
};
var ORB_REST = {
    scale: 1,
    cloudScale: 1,
    cloudOpacity: 1,
    cloudSaturate: 1,
    core: 'vw-pulse 4.5s ease-in-out infinite',
    fast: 0,
    swirl: 0,
    spinner: false,
    ripple: false,
};
var ERROR_AURA = { scale: 0.75, opacity: 0.45, saturate: 0, seconds: 8 };
// Copy and motion per state, from the design canvas.
exports.SCREENS = {
    ready: {
        title: 'Talk to us',
        subtitle: 'Ask anything out loud. Answers in real time.',
        status: 'Voice assistant',
        dot: 'idle',
        bars: 'rest',
        aura: { scale: 0.82, opacity: 0.85, saturate: 1, seconds: 6 },
        orb: ORB_REST,
        cta: true,
    },
    connecting: {
        title: 'Connecting',
        subtitle: 'Setting up a secure line…',
        status: 'Connecting…',
        dot: 'warn',
        bars: 'dots',
        aura: { scale: 0.7, opacity: 0.7, saturate: 1, seconds: 2 },
        orb: __assign(__assign({}, ORB_REST), { scale: 0.92, cloudScale: 0.72, cloudOpacity: 0.6, core: 'none', spinner: true }),
        controls: true,
        micDisabled: true,
    },
    listening: {
        title: 'Listening',
        subtitle: 'Ask me anything',
        dot: 'live',
        bars: 'listen',
        aura: { scale: 1, opacity: 1, saturate: 1, seconds: 5 },
        orb: ORB_REST,
        controls: true,
    },
    userSpeaking: {
        title: 'Listening',
        subtitle: 'Go on, I’m following',
        dot: 'live',
        bars: 'listen',
        aura: { scale: 1.12, opacity: 1, saturate: 1, seconds: 1.6 },
        orb: __assign(__assign({}, ORB_REST), { scale: 1.03, core: 'vw-corepulse 1.1s ease-in-out infinite', fast: 0.45, swirl: 0.6, ripple: true }),
        controls: true,
    },
    thinking: {
        title: 'Thinking',
        subtitle: 'Finding the best answer…',
        dot: 'live',
        bars: 'wave',
        aura: { scale: 0.95, opacity: 1, saturate: 1, seconds: 2.4 },
        orb: __assign(__assign({}, ORB_REST), { core: 'vw-pulse 3s ease-in-out infinite', fast: 1, swirl: 1 }),
        controls: true,
    },
    speaking: {
        title: 'Speaking',
        subtitle: 'Just start talking to interrupt',
        dot: 'live',
        bars: 'speak',
        aura: { scale: 1.16, opacity: 1, saturate: 1, seconds: 1.2 },
        orb: __assign(__assign({}, ORB_REST), { scale: 1.04, core: 'vw-corepulse 1.8s ease-in-out infinite', fast: 0.45, swirl: 0.6 }),
        controls: true,
    },
    muted: {
        title: 'You’re muted',
        subtitle: 'Unmute when you’re ready to talk',
        dot: 'live',
        bars: 'flat',
        aura: { scale: 0.82, opacity: 0.5, saturate: 0.12, seconds: 6 },
        orb: __assign(__assign({}, ORB_REST), { scale: 0.94, cloudScale: 0.92, cloudOpacity: 0.6, cloudSaturate: 0.15, core: 'none' }),
        controls: true,
    },
    noMic: {
        title: 'No microphone found',
        subtitle: 'Plug in a headset or microphone, then try again.',
        status: 'Not connected',
        dot: 'idle',
        icon: 'headset',
        aura: ERROR_AURA,
    },
    micBlocked: {
        title: 'Microphone access is off',
        subtitle: 'Allow microphone access to talk to the assistant.',
        status: 'Not connected',
        dot: 'idle',
        icon: 'lock',
        aura: ERROR_AURA,
        steps: true,
    },
};
